import { GeneralHistoryPersonalCompleteModel } from "src/app/model/general/history-personal-complete";
import { GeneralHistoryViewModel } from "src/app/model/general/history.view";

export interface HistoryState {
  personId: number;
  saving: boolean;
  personalHistories: GeneralHistoryViewModel[];
  personalCompleteHistory: GeneralHistoryPersonalCompleteModel;
  familyHistories: GeneralHistoryViewModel[];
  totalSaved: number;
  save: boolean;
}

export const historyIS: HistoryState = {
  personId: -1,
  saving: false,
  personalHistories: [],
  personalCompleteHistory: {},
  familyHistories: [],
  totalSaved: 0,
  save: false,
};
